export enum Permiso {

    /* #region Administracion */
    ConsultarAdministracion = "1",
    /* #endregion */

    /* #region Tablero */
    ConsultarTablero = "2",
    /* #endregion */

    /* #region Modulos */
    AgregarModulo = "3",
    ActualizarModulo = "4",
    EliminarModulo = "5",
    ConsultarModulos = "6",
    /* #endregion */

    /* #region Permisos */
    AgregarPermiso = "7",
    ActualizarPermiso = "8",
    EliminarPermiso = "9",
    ConsultarPermisos = "10",
    /* #endregion */

    /* #region Bitacora */
    ConsultarBitacora = "11",
    /* #endregion */

    /* #region Entidades */
    ConsultarEntidades = "12",
    /* #endregion */

    /* #region Cadena */
    AgregarCadena = "13",
    ActualizarCadena = "14",
    EliminarCadena = "15",
    ConsultarCadena = "16",
    /* #endregion */

    /* #region Sucursal */
    AgregarSucursal = "17",
    ActualizarSucursal = "18",
    EliminarSucursal = "19",
    ConsultarSucursal = "20",
    /* #endregion */

    /* #region Caja */
    AgregarCaja = "21",
    ActualizarCaja = "22",
    EliminarCaja = "23",
    ConsultarCaja = "24",
    /* #endregion */

    /* #region Usuarios */
    AgregarUsuario = "25",
    ActualizarUsuario = "26",
    EliminarUsuario = "27",
    ConsultarUsuario = "28",
    RestaurarContrasenaUsuarios = "105",
    /* #endregion */

    /* #region Centro de Pagos */
    ConsultaDePago = "29",
    /* #endregion */

    /* #region clientes */
    AgregarCliente = "30",
    ActualizarCliente = "31",
    EliminarCliente = "32",
    ConsultarCliente = "33",
    /* #endregion */

    /* #region Metodos*/
    AgregarMetodoPago = "34",
    ActualizarMetodoPago = "35",
    EliminarMetodoPago = "36",
    ConsultarMetodoPago = "37",
    /* #endregion */

    /* #region Desarrolladores */
    ConsultarDocumentacion = "38",
    ConsultarAutenticacion = "77",
    ConsultarTransaccionesD = "78",
    ConsultarClientesD = "79",
    ConsultarCadenasD = "80",
    ConsultarSucursalesD = "81",
    ConsultarCajasD = "82",
    ConsultarUsuariosD = "83",
    ConsultarRolesD = "84",
    ConsultarPuntoVentaD = "85",
    ConsultarReporteVentasD = "86",
    ConsultarAnalyticsD = "87",
    ConsultarSaldosD = "88",
    ConsultarDepositosD = "89",
    ConsultarBienvenidaD = "90",
    ConsultarModulosD = "91",
    ConsultarPermisosD = "92",
    ConsultarLadasTelefonicasD = "93",
    ConsultarSwitcherProveedorD = "94",
    ConsultarVentaSaldoD = "95",
    ConsultarTraspasarSaldoD = "96",
    ConsultarPerfilUsuarioD = "97",
    ConsultarProveedoresD = "98",
    ConsultarSwitcherD = "99",
    /* #endregion */

    /* #region Saldo*/
    AsignarSaldos = "39",
    /* #endregion */

    /* #region Asignación*/
    ConsultarAsignacion = "40",
    /* #endregion */

    /* #region Saldos*/
    SaldoCliente = "41",
    SaldoCadena = "42",
    SaldoSucursal = "43",
    SaldoCaja = "44",
    Depositos = "45",
    VistaSaldo = "57",
    /* #endregion */

    /* #region Roles*/
    AgregarRol = "46",
    ActualizarRol = "47",
    EliminarRol = "48",
    ConsultarRoles = "49",
    /* #endregion */

    /* #region Reportes*/
    ConsultarTransacciones = "50",
    /* #endregion */

    /* #region Depositos*/
    AgregarDeposito = "51",
    ConsultarDepositos = "52",
    /* #endregion */

    /* #region Reportes*/
    ConsultarTraspasos = "53",
    ConsultarCorteDelDia = "100",
    ConsultarConciliaciones = "101",
    ConsultarEstadosCuenta = "102",
    ConsultarConciliacionesProv="103",
    ConsultarReporteGastos="104",
    /* #endregion */

    /**#region Centro de Pagos */
    ReporteVentas = "54",
    ConfirmacionNumero = "55",
    EnmascararNumeros = "56",
    POSMasivo = "62",
    /* #endregion */

    /**#region Switcher */
    ConsultaProvedores = "58",
    /* #endregion */

    /**#region Admin */
    DescripcionAudible = "59",
    /* #endregion */

    /* #region Ladas*/
    ConsultarLadas = "63",
    AgregarLadas = "64",
    ActualizarLadas = "65",
    EliminarLadas = "66",
    /* #endregion */

    /* #region CompraProveedores*/
    ConsultarCompraProveedores = "67",
    AgregarCompraProveedores = "68",
    ActualizarCompraProveedores = "69",
    EliminarCompraProveedores = "70",
    /* #endregion */

    /* #region Proveedores*/
    AgregarProveedor = "71",
    ConsultarProveedores = "72",
    ActualizarProveedores = "73",
    EliminarProveedores	 = "74",
    SwitcherProveedores	 = "75",
    /* #endregion */

    /**Saldos */
    Saldos = "76"
    /* #endregion */


}